import { ChatListControlled, ScrollView, XPPlatform as Platform } from '@my/ui'
//import { Platform } from 'react-native'

// ChatMessages Props
interface ChatMessagesProps {
  messages: any[];
  actionFns?: {
    helpfulnessFn: (item: any, rating: 'helpful' | 'not-helpful') => void;
    reportFn: (item: any, issueDetails: string) => void;
  }
}

// ChatMessages Component
export const ChatMessages: React.FC<ChatMessagesProps> = ({ messages, actionFns }) => (
  /* <ScrollView
    width="90%"
    overScrollMode="never"
    $platform-native={{ width: '100%' }}
    showsVerticalScrollIndicator={false}
    scrollEnabled={true}
    contentContainerStyle={{ maxHeight: Platform.select({ web: 110 }) }}
  > */
    <ChatListControlled messages={messages} actionFns={actionFns} />
  /* </ScrollView> */
);
